import { getIsMenuTypeItemHiddenCore } from './chunk-MFMTSPFX.mjs';

// src/helpers/factories/menu/cardFactories/menuTypes/menuTypeAssignedItemsFactory.ts
var menuTypeAssignedItemsFactoryCore = (items, menuTypeAssignedItemIds, menuTypeId, handleDeleteItem, categories, subcategories, menuTypes, enableSimpleMode) => menuTypeAssignedItemIds.map((id) => {
  var _a, _b;
  const item = items[id];
  if (item) {
    const status = (_a = item.menuTypeVersions[menuTypeId]) == null ? void 0 : _a.active;
    return {
      id: item.itemId,
      title: item.name,
      onDelete: handleDeleteItem,
      onPress: () => console.info(id),
      status,
      isStatusActive: status,
      isHidden: getIsMenuTypeItemHiddenCore(
        ((_b = item.menuTypeVersions[menuTypeId]) == null ? void 0 : _b.categoriesSubcategories) || {},
        categories,
        subcategories,
        "items",
        item.itemId,
        menuTypeId,
        menuTypes,
        enableSimpleMode
      ).isHidden
    };
  } else
    return null;
}).filter((value) => value !== null);

export { menuTypeAssignedItemsFactoryCore };
